var exports = {
  "i": "xaee3c4fa--fac4f7--wrapper",
};

module.exports = exports;
